import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ServiceOffersService } from "../../../_services/serviceoffers.service";
import { CustomersService } from "../../../_services/customers.service";
import { StatisticsService } from "../../../_services/statistics.service";
import { ServiceAddonsService } from "../../../_services/serviceaddons.service";
import { Agreement } from "../../../_models/agreement";
import { ProlongingsAgreement } from "../../../_models/prolongings/prolongingsagreement";
import { Dealer } from "../../../_models/dealer";
import { Http } from "@angular/http";
import { DealersService } from "app/_services/dealers.service";
import { ServiceOffer } from "../../../_models/serviceoffer";
import { ServiceAddon } from "../../../_models/serviceaddon";
import { StatisticEvent } from "../../../_models/statisticevent";
import { Customer } from "../../../_models/customer";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { CookieService, CookieOptions } from 'ngx-cookie';
import { Subscription } from "rxjs";
import {
  ToasterModule,
  ToasterService,
  ToasterConfig,
} from "angular2-toaster/angular2-toaster";
import { environment } from "../../../../environments/environment";
import { EnvironmentService } from "app/_services";
import { NgForm } from "@angular/forms";
import { ProlongingsAgreementService } from "app/_services/matrix/products/prolongings-agreement.service";
import { Car } from "app/_models";

@Component({
  selector: "prolongings-checkout",
  templateUrl: "./checkout.component.html",
  providers: [
    ServiceOffersService,
    ServiceAddonsService,
    CustomersService,
    ProlongingsAgreementService,
    DealersService,
    StatisticsService,
  ],
})
export class ProlongingsCheckoutComponent implements OnInit {
  private serviceoffers: ServiceOffer[];
  private serviceaddons: ServiceAddon[];
  private customer: Customer;
  private data: Customer;
  private mauticCustomer: Customer;

  private statisticsService: StatisticsService;
  public hasResponded: boolean = false;
  public disableEmailField: boolean = true;

  private customerid: string = "";
  private errorMessage: string = "";
  public isLoading: boolean = true;
  private calcStartupCost: boolean = true;
  private confirmation: boolean = false;
  private userId: string;
  public customerAccept: boolean = false;
  public usedcar: Car[];
  private dealer: Dealer;

  public optin: boolean = true;
  public calculatedPrice: number;
  private serviceaddonslist: string;
  private carname: string = "";
  private payment_method: string = "";
  public startupPrice: number;
  public customer_data: Customer = new Customer();
  public prolongingsAgreement: ProlongingsAgreement;
  public completedData;

  public pdf: any = "";

  private subscription: Subscription;

  private toasterService: ToasterService;
  private cookieService: CookieService;

  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 5000,
  });

  private host: String = environment.host;
  private port: String = environment.port;
  private authenticateUrl = this.environmentService.getBaseURL() + "/";

  public dealercalc: boolean;

  private offerSpecialPrice: boolean = false;
  private specialPrice: number = null;

  private showSearchByReg: boolean = true;

  constructor(
    toasterService: ToasterService,
    statisticsService: StatisticsService,
    private agreementsService: ProlongingsAgreementService,
    private customersService: CustomersService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private serviceAddonsService: ServiceAddonsService,
    private serviceoffersService: ServiceOffersService,
    private dealerService: DealersService,
    private modalService: NgbModal,
    private environmentService: EnvironmentService,
    cookieService: CookieService
  ) {
    this.toasterService = toasterService;
    this.statisticsService = statisticsService;
    this.activatedRoute = activatedRoute;
    this.cookieService = cookieService;
  }

  ngOnInit() {
    this.isLoading = true;

    this.subscription = this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        if (param["regsearch"] && param["regsearch"] == "false") {
          this.showSearchByReg = false;
        }
      }
    );

    this.activatedRoute.params.subscribe((params) => {
      this.prolongingsAgreement = JSON.parse(sessionStorage.getItem("prolongingsAgree"));
      this.usedcar = this.prolongingsAgreement.car as Car[];
      this.completedData = JSON.parse(sessionStorage.getItem("completedData"));
      this.prolongingsAgreement.sellerInitials =
        sessionStorage.getItem("sellerInitial");
      this.customerid = this.prolongingsAgreement.customer;
      try {
        this.userId = JSON.parse(localStorage.getItem("currentUser"))._id;
        if (this.customerid === this.userId) {
          this.customerAccept = true;
        }
      } catch (e) {

      }
      //If seller initials is set, present the special price option
      if (
        this.prolongingsAgreement.sellerInitials != null &&
        this.prolongingsAgreement.sellerInitials != ""
      ) {
        this.offerSpecialPrice = true;
      }

      this.customersService.read(this.customerid).subscribe(
        /* happy path */ (p) => (this.customer = p),
        /* error path */ (e) => (this.errorMessage = e),
        /* onComplete */ () => {
          this.data = this.customer;

          this.customersService
            .queryFromMautic(237, this.customer.dealer[0]._id, {
              attributeName: "regnr",
              attributeValue: this.customer.regnr,
            })
            .subscribe(
              (customer) => {
                if (!this.data.postnummer) {
                  this.data.postnummer = customer.postalcode;
                }
                if (!this.data.by) {
                  this.data.by = customer.city;
                }
                if (!this.data.address) {
                  this.data.address = customer.address 
                }
                if (this.showSearchByReg == true) {
                  this.customer_data = this.data;
                }
                if (this.customer_data.telefonnummer) {
                  if (this.customer_data.telefonnummer.length > 8) {
                    const phoneLength = this.customer_data.telefonnummer.length;
                    this.customer_data.telefonnummer = this.customer_data.telefonnummer.slice(phoneLength-8);
                  }
                }
                this.mauticCustomer = customer;
                if (!this.mauticCustomer.email) {
                  this.disableEmailField = false;
                }
              },
              (e) => (this.errorMessage = e),
              () => {
                this.dealerService
                  .get(this.customer_data.dealer[0]._id)
                  .subscribe(
                    (d) => {
                      this.dealer = d;
                    },
                    (e) => (this.errorMessage = e),
                    () => {
                      this.isLoading = false;
                    }
                  );
              }
            );
        }
      );
    });

    this.activatedRoute.queryParams.subscribe((params) => {
      this.dealercalc = params["dealercalc"] == "true";
    });
  }

  saveAgreement(checkoutForm: NgForm) {
    checkoutForm.form.disable();

    let agreementItem: Partial<ProlongingsAgreement> = {
      ...this.prolongingsAgreement,
      status: true,
      dealer_id: this.customer_data.dealer[0]._id,
      calculatorType: "online",
      customerAccept: this.customerAccept,
      regnr: this.mauticCustomer.regnr,
      department: this.mauticCustomer.department,
    };

    // If special price is set, then set the agreement price to that
    if (this.specialPrice != null) {
      agreementItem.price = this.specialPrice;
    }
    // If agreement already exists
    if (
      this.prolongingsAgreement &&
      this.prolongingsAgreement._id != undefined
    ) {
      this.isLoading = true;
      this.agreementsService
        .update(agreementItem, this.completedData.numberOfPayMonths)
        .subscribe(
          /* happy path */ (r) => {
            this.agreementDone();

            checkoutForm.form.enable();
            this.isLoading = false;
          },
          /* error path */ (e) => {
            this.errorMessage = e;

            checkoutForm.form.enable();
            this.isLoading = false;
          }
        );
    } else {
      this.isLoading = true;
      let customerItem: Customer = new Customer();
      customerItem._id = this.customerid;
      customerItem.name = this.customer_data.name;
      customerItem.address = this.customer_data.address;
      customerItem.postnummer = this.customer_data.postnummer;
      customerItem.by = this.customer_data.by;
      customerItem.email = this.customer_data.email;
      customerItem.telefonnummer = this.customer_data.telefonnummer;
      customerItem.regnr = this.customer_data.regnr;
      customerItem.firstreg = this.mauticCustomer.firstreg;
      this.customersService.update(customerItem).subscribe(
        /* happy path */ (r) => {},
        /* error path */ (e) => (this.errorMessage = e),
        /* onComplete */ () => {
          this.agreementsService
            .create(agreementItem, this.completedData.numberOfPayMonths)
            .subscribe(
              /* happy path */ (r) => {
                this.agreementDone();
                this.prolongingsAgreement = r;

                checkoutForm.form.enable();
                this.isLoading = false;
              },
              /* error path */ (e) => {
                this.errorMessage = e;

                checkoutForm.form.enable();
                this.isLoading = false;
              }
            );
        }
      );
    }

    let statisticEvent: StatisticEvent = new StatisticEvent();
    statisticEvent.customer = this.customer._id;
    statisticEvent.event = "prolonging_checkout_complete";
    this.statisticsService.sendEvent(statisticEvent).subscribe(
      /* happy path */ (r) => {
        console.log("prolonging checkout complete event tracked");
      },
      /* error path */ (e) => {
        console.error(`prolonging checkout complete event error: ${e}`);
      }
    );
  }

  previewPDF() {
    let customerItem: Customer = new Customer();
    customerItem._id = this.customerid;
    customerItem.name = this.customer_data.name;
    customerItem.address = this.customer_data.address;
    customerItem.postnummer = this.customer_data.postnummer;
    customerItem.by = this.customer_data.by;
    customerItem.email = this.customer_data.email;
    customerItem.telefonnummer = this.customer_data.telefonnummer;
    customerItem.regnr = this.customer_data.regnr;
    customerItem.firstreg = this.mauticCustomer.firstreg;

    let agreementItem: Partial<ProlongingsAgreement> = {
      ...this.prolongingsAgreement,
      status: false,
      dealer_id: this.customer_data.dealer[0]._id,
      calculatorType: "online",
      customerAccept: false,
      regnr: this.customer_data.regnr,
    };

    // If special price is set, then set the agreement price to that
    if (this.specialPrice != null) {
      agreementItem.price = this.specialPrice;
    }

    this.customersService.update(customerItem).subscribe(
      /* happy path */ (r) => {},
      /* error path */ (e) => (this.errorMessage = e),
      /* onComplete */ () => {
        this.isLoading = true;
        if (this.prolongingsAgreement._id == undefined) {
          this.agreementsService
            .create(agreementItem, this.completedData.numberOfPayMonths)
            .subscribe(
              /* happy path */ (r) => {
                this.prolongingsAgreement = r;
                this.prolongingsAgreement.car = this.usedcar;
                this.isLoading = false;
                var tabWindowId = window.open("about:blank", "_blank");
                const redirectUrl =
                  this.authenticateUrl +
                  "api/agreement/prolongings/offer_" +
                  r._id +
                  ".pdf";
                window.setTimeout(function () {
                  tabWindowId.location.href = redirectUrl;
                }, 3000);
              },
              /* error path */ (e) => {
                const newAgreement = JSON.parse(e._body);

                if (newAgreement.agreementGenerated != "") {
                  this.prolongingsAgreement = newAgreement.agreementGenerated;
                  this.prolongingsAgreement.car = this.usedcar;
                } else {
                  this.prolongingsAgreement = JSON.parse(
                    sessionStorage.getItem("prolongingsAgree")
                  );
                }
                this.errorMessage = e;
                this.isLoading = false;
              }
            );
        } else {
          this.agreementsService
            .update(agreementItem, this.completedData.numberOfPayMonths)
            .subscribe(
              /* happy path */ (r) => {
                this.prolongingsAgreement = r;
                this.prolongingsAgreement.car = this.usedcar;
                var tabWindowId = window.open("about:blank", "_blank");
                this.isLoading = false;

                const redirectUrl =
                  this.authenticateUrl +
                  "api/agreement/prolongings/offer_" +
                  this.prolongingsAgreement._id +
                  ".pdf";

                window.setTimeout(function () {
                  tabWindowId.location.href = redirectUrl;
                }, 3000);
              },
              /* error path */ (e) => {
                const newAgreement = JSON.parse(e._body);

                if (newAgreement.agreementGenerated != "") {
                  this.prolongingsAgreement = newAgreement.agreementGenerated;
                  this.prolongingsAgreement.car = this.usedcar;
                } else {
                  this.prolongingsAgreement = JSON.parse(
                    sessionStorage.getItem("prolongingsAgree")
                  );
                }
                this.errorMessage = e;
                this.isLoading = false;
              }
            );
        }
      }
    );
  }

  previewTC() {
    let customerItem: Customer = new Customer();
    customerItem._id = this.customerid;
    customerItem.name = this.customer_data.name;
    customerItem.address = this.customer_data.address;
    customerItem.postnummer = this.customer_data.postnummer;
    customerItem.by = this.customer_data.by;
    customerItem.email = this.customer_data.email;
    customerItem.telefonnummer = this.customer_data.telefonnummer;
    customerItem.regnr = this.customer_data.regnr;
    customerItem.firstreg = this.mauticCustomer.firstreg;

    let agreementItem: Partial<ProlongingsAgreement> = {
      ...this.prolongingsAgreement,
      status: false,
      dealer_id: this.customer_data.dealer[0]._id,
      calculatorType: "online",
      customerAccept: false,
      regnr: this.customer_data.regnr,
    };

    this.customersService.update(customerItem).subscribe(
      /* happy path */ (r) => {},
      /* error path */ (e) => (this.errorMessage = e),
      /* onComplete */ () => {
        this.isLoading = true;
        if (this.prolongingsAgreement._id == undefined) {
          this.agreementsService
            .create(agreementItem, this.completedData.numberOfPayMonths)
            .subscribe(
              /* happy path */
              (r) => {
                this.prolongingsAgreement = r;
                this.prolongingsAgreement.car = this.usedcar;
                this.isLoading = false;
                var tabWindowId = window.open("about:blank", "_blank");
                const redirectUrl =
                  this.authenticateUrl +
                  "api/agreement/prolongings/tc_" +
                  r._id +
                  ".pdf";
                window.setTimeout(function () {
                  tabWindowId.location.href = redirectUrl;
                }, 3000);
              },
              /* error path */
              (e) => {
                const newAgreement = JSON.parse(e._body);

                if (newAgreement.agreementGenerated != "") {
                  this.prolongingsAgreement = newAgreement.agreementGenerated;
                  this.prolongingsAgreement.car = this.usedcar;
                } else {
                  this.prolongingsAgreement = JSON.parse(
                    sessionStorage.getItem("prolongingsAgree")
                  );
                }

                this.errorMessage = e;
                this.isLoading = false;
              }
            );
        } else {
          this.agreementsService
            .update(agreementItem, this.completedData.numberOfPayMonths)
            .subscribe(
              /* happy path */
              (r) => {
                this.prolongingsAgreement = r;
                this.prolongingsAgreement.car = this.usedcar;

                var tabWindowId = window.open("about:blank", "_blank");
                this.isLoading = false;
                tabWindowId.location.href =
                  this.authenticateUrl +
                  "api/agreement/prolongings/tc_" +
                  this.prolongingsAgreement._id +
                  ".pdf";
              },
              /* error path */
              (e) => {
                const newAgreement = JSON.parse(e._body);

                if (newAgreement.agreementGenerated != "") {
                  this.prolongingsAgreement = newAgreement.agreementGenerated;
                  this.prolongingsAgreement.car = this.usedcar;
                } else {
                  this.prolongingsAgreement = JSON.parse(
                    sessionStorage.getItem("prolongingsAgree")
                  );
                }
                this.errorMessage = e;
                this.isLoading = false;
              }
            );
        }
      }
    );
  }

  viewPDF() {
    let agreementItem: Partial<ProlongingsAgreement> = {};
    let customerItem: Customer = new Customer();
    agreementItem = this.prolongingsAgreement;
    customerItem._id = this.customerid;
    customerItem.name = this.customer_data.name;
    customerItem.address = this.customer_data.address;
    customerItem.postnummer = this.customer_data.postnummer;
    customerItem.by = this.customer_data.by;
    customerItem.email = this.customer_data.email;
    customerItem.telefonnummer = this.customer_data.telefonnummer;
    customerItem.firstreg = this.mauticCustomer.firstreg;

    agreementItem.dealer_id = this.customer_data.dealer[0]._id;
    agreementItem.status = false;

    var tabWindowId = window.open("about:blank", "_blank");

    this.customersService.update(customerItem).subscribe(
      /* happy path */ (r) => {},
      /* error path */ (e) => (this.errorMessage = e),
      /* onComplete */ () => {
        if (this.prolongingsAgreement._id == undefined) {
          this.agreementsService
            .create(agreementItem, this.completedData.numberOfPayMonths)
            .subscribe(
              /* happy path */
              (r) => {
                this.prolongingsAgreement = r;
                this.isLoading = false;
                tabWindowId.location.href =
                  this.authenticateUrl +
                  "api/agreement/prolongings/agreement_" +
                  r._id +
                  ".pdf";
              },
              /* error path */
              (e) => {
                this.errorMessage = e;
                this.isLoading = false;
              }
            );
        } else {
          this.agreementsService
            .update(agreementItem, this.completedData.numberOfPayMonths)
            .subscribe(
              /* happy path */
              (r) => {
                this.isLoading = false;
                tabWindowId.location.href =
                  this.authenticateUrl +
                  "api/agreement/prolongings/agreement_" +
                  this.prolongingsAgreement._id +
                  ".pdf";
              },

              /* error path */
              (e) => {
                this.errorMessage = e;
                this.isLoading = false;
              }
            );
        }
      }
    );
  }

  agreementDone() {
    //sessionStorage.removeItem("prolongingsAgree");
    this.cookieService.remove("prolongingsAgree");
    this.cookieService.remove("completedData");
    this.confirmation = true;
  }

  back() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/landingpages/prolongings/order-flow/checkout.component.ts